<div #container [ngClass]="'p-contextmenu p-component ui-corner-all ui-shadow'" [class]="styleClass" [ngStyle]="style">
  <iu-prime-context-menu-sub [item]="model" root="root"></iu-prime-context-menu-sub>
</div>
